import React, { useEffect, useState} from "react";
import { Accordion, AccordionDetails, AccordionSummary, Box, Chip, CircularProgress, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import { ExpandMore } from "@mui/icons-material"
import ProjectGrid from "./ProjectGrid";
import { ProjectType, SkillType } from "../types";
import data from '../data.json';
import BASE_URL from "../config";

function Project() {
    const [projectsType, setProjectsType] = useState<string>('Full stack development');
    const [skillsExpand, setSkillExpand] = useState<boolean>(true);
    const [skills, setSkills] = useState<SkillType[]>(data.allSkills);
    const [loading, setLoading] = useState<boolean>(false);
    const [projectsData, setProjectsData] = useState<ProjectType[] | any>(data.personal);

    // useEffect(() => {
    //   const fetchProjectSkills = async () => {
    //     try {
    //       let response = await fetch(BASE_URL+'getAllSkills');
    //       if (!response.ok) {
    //         throw new Error('Network response was not ok');
    //       }
    //       let result = await response.json()
    //       setSkills(result);
    //       console.log("allSkills", result);
    //       response = await fetch(BASE_URL+'getPersonalDetails');
    //       if (!response.ok) {
    //         throw new Error('Network response was not ok');
    //       }
    //       result = await response.json();
    //       console.log("Prsonel", result);
    //       setProjectsData(result);
    //     } catch (error) {
    //     } finally {
    //       setLoading(false);
    //     }
    //   };
    //   fetchProjectSkills();
    // }, [])

    const skillSetDisplay = () => {
      let skill = [...skills]
      const groupedData: Record<string, SkillType[]> = skill.reduce((result, item) => {
        const groupKey = item.category;
        if (!result[groupKey]) {
          result[groupKey] = [];
        }
        result[groupKey].push(item);
        return result;
      }, {} as Record<string, SkillType[]>);
    
      return (
        <>
          {Object.entries(groupedData).map(([groupKey, items]) => (
            <div key={groupKey}>
              <Typography variant="subtitle1">{groupKey}</Typography>
              <Box display="flex" flexWrap="wrap">
                {items.map((item) => (
                  <React.Fragment key={item.id}>
                    <Chip label={item.name} style={{ margin: '2px', paddingLeft: '5px' }} />
                  </React.Fragment>
                ))}
              </Box>
            </div>
          ))}
        </>
      );
    };
      
    return (
      <Box>
        {!loading ? (
            <div>
            <Accordion expanded={skillsExpand} 
              onChange={() => setSkillExpand(!skillsExpand)} 
              style={{marginBottom: '20px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)'}}
            >
              <AccordionSummary
                expandIcon={<ExpandMore />}
                aria-controls="panel1bh-content"
                id="panel1bh-header"
              >
                <Typography variant="h5">
                  Skills
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
              {skillSetDisplay()}
              </AccordionDetails>
            </Accordion>
            <br></br>
            <Box display="flex" justifyContent="center">
              <ToggleButtonGroup
              value={projectsType}
              exclusive
              onChange={(_, type: string) => type!==null && setProjectsType(type)}
              aria-label="text alignment"
              style={{paddingBottom: '20px'}}
              >
                <ToggleButton value="Full stack development" aria-label="left aligned">
                  <Typography>Full Stack Projects</Typography>
                </ToggleButton>
                <ToggleButton value="Machine Learning" aria-label="centered">
                <Typography>Machine Learning Projects</Typography>
                </ToggleButton>
            </ToggleButtonGroup>
          </Box>
        <ProjectGrid data={projectsData} type={projectsType} />
        </div>
        ) : <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
            <CircularProgress />
            </div>}
      </Box>)
}
export default Project;
